import { getAiUsageCount, updateAiUsageCount } from "./api";

/**
 * 指定されたサービス名について、当月のAI利用回数を1増やします。
 *
 * @param service 利用回数をカウントアップする対象のサービス名（例: "chat", "vision", "summarize" など）
 * @returns カウントアップが成功した場合は true を返します。
 */
export const countUpAiUsage = async (service: string): Promise<boolean> => {
    const now = new Date();
    const month = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}`;
    try {
        const currentCount = await getAiUsageCount(service, month);
        await updateAiUsageCount(service, month, currentCount + 1);
        return true;
    } catch (error) {
        throw error;
    }
};
